// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"227":"895b4fed","411":"98597145","523":"ff053832","524":"4a574bb5","546":"f902803d","600":"ae6d16ac","640":"23766981"}[chunkId] + ".chunk.css";
};